interface CheckIconProps {
  className?: string;
}

export function CheckIcon({ className }: CheckIconProps) {
  return (
    <svg
      width="222"
      height="222"
      viewBox="0 0 222 222"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="28"
        y="28"
        width="166"
        height="166"
        rx="33"
        fill="url(#paint0_radial_7070_21622)"
        fill-opacity="0.34"
      />
      <path
        d="M75.8284 116.203C74.2663 114.641 74.2663 112.109 75.8284 110.547L86.9981 99.3769C88.5602 97.8148 91.0929 97.8148 92.655 99.3769L106.653 113.375L89.8266 130.202L75.8284 116.203Z"
        fill="url(#paint1_linear_7070_21622)"
      />
      <path
        d="M89.8264 130.198L142.196 77.8286C143.758 76.2666 146.29 76.2665 147.852 77.8286L159.022 88.9983C160.584 90.5604 160.584 93.0931 159.022 94.6552L109.481 144.196C107.919 145.758 105.387 145.758 103.825 144.196L89.8264 130.198Z"
        fill="url(#paint2_linear_7070_21622)"
      />
      <rect
        x="29"
        y="29"
        width="164"
        height="164"
        rx="32"
        stroke="url(#paint3_linear_7070_21622)"
        strokeWidth="2"
      />
      <defs>
        <radialGradient
          id="paint0_radial_7070_21622"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-66.4 126.941 -126.941 -80.7742 172.973 -4.34558)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#699339" />
          <stop offset="1" stop-color="#0F0F0D" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_7070_21622"
          x1="81.4133"
          y1="104.962"
          x2="114.952"
          y2="138.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#699339" />
          <stop offset="1" stop-color="#202D11" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7070_21622"
          x1="128.351"
          y1="108.5"
          x2="153.437"
          y2="83.4135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7DAF43" />
          <stop offset="1" stop-color="#465831" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7070_21622"
          x1="151.505"
          y1="111"
          x2="117.438"
          y2="179.181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#283815" />
          <stop offset="1" stop-color="#283815" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
